<nav class='points-banner'>
    <div class="banner-container container-constraint">
      <div class="iconImageContainer"><img src="../../../../assets/images/rewards/Rewards Icon Mobile.png" alt="rewards icon">
      </div>
      <div class="selPointsRow">
        <div class="pointsAvailable">Points Available -<span
            class="pointsValue">{{myPoints ? myPoints :  0}}</span></div>
      </div>
      <a aria-label="Change Location" class="banner-btn pull-right " (click)="help()">Help</a>
    </div>
  </nav>